import { useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { activitiesQueryOptions } from "../api/activities-query";
import type { ActivityFilters } from "../constants/query-keys";

export function useActivities(filters: ActivityFilters) {
  const { i18n } = useTranslation();
  const merged: ActivityFilters = { ...filters, lang: filters.lang ?? i18n.language };
  return useSuspenseQuery(activitiesQueryOptions(merged));
}
